import { ServerConfig } from "@/config/config";
import { Axios } from "./auth-service";
import { Script } from "@/models/script";
import { ISelectItem } from "winfakt-vue-components";

class ScriptServiceClass{
	getUrl(dossierId:number):string{
		return `${ServerConfig.mainAppHost}/dossier/${dossierId}/scripts`;
	}

	async getScripts(dossierId:number):Promise<Script[]>{
		let result = await Axios.get(this.getUrl(dossierId));
		return result.data.map((s:any)=>new Script(s));
	}

	async getScriptTypes(dossierId:number):Promise<ISelectItem<string>[]>{
		let result = await Axios.get(`${this.getUrl(dossierId)}/types`);
		return result.data.map((v:any)=>{
			return {
				text: v.Text,
				value: v.Value
			} as ISelectItem<string>;
		});
	}

	async createScript(dossierId:number, script:Script):Promise<Script>{
		let result = await Axios.post(this.getUrl(dossierId), script.getJSON());
		return new Script(result.data);
	}

	async getScript(dossierId:number, scriptId:number):Promise<Script>{
		let result = await Axios.get(`${this.getUrl(dossierId)}/${scriptId}`);
		return new Script(result.data);
	}

	async updateScript(dossierId:number, script:Script):Promise<Script>{
		let result = await Axios.put(`${this.getUrl(dossierId)}/${script.ID}`, script.getJSON());
		return new Script(result.data);
	}

	async deleteScript(dossierId:number, scriptId:number):Promise<void>{
		await Axios.delete(`${this.getUrl(dossierId)}/${scriptId}`);
	}
};

export const ScriptService = new ScriptServiceClass();